import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=556d4bf8&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556d4bf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\shop-admin-vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('556d4bf8')) {
      api.createRecord('556d4bf8', component.options)
    } else {
      api.reload('556d4bf8', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=556d4bf8&scoped=true&", function () {
      api.rerender('556d4bf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hc/customer-change/edit.vue"
export default component.exports